import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchPosts } from "../store/slices/posts";
import type { AppDispatch } from "../store";

type RefreshOpts = {
    username?: string | undefined;
    targetUsername?: string;
    followedOnly?: boolean;
    replace?: boolean;
    cursor?: string;
    onDone?: () => void;
};

export const useRefreshPosts = (setFeedLoading: (val: boolean) => void) => {
    const dispatch = useDispatch<AppDispatch>();

    const refreshPosts = useCallback(
        (opts: RefreshOpts = {}) => {
            setFeedLoading(true);
            const { username, targetUsername, followedOnly, replace = true, cursor, onDone } = opts;

            let filter: "all" | "followed" | undefined = undefined;
            if (followedOnly !== undefined) filter = followedOnly ? "followed" : "all";

            dispatch(
                fetchPosts({ replace: replace, targetUsername: targetUsername ?? null, username: username ?? null, filter: filter, cursor })
            )
                .unwrap()
                .finally(() => {
                    setFeedLoading(false);
                    if (onDone) onDone();
                });
        },
        [dispatch, setFeedLoading]
    );

    return refreshPosts;
};
